<template>
    <Breadcrumb page-title="Configure Workflow" page-section=""> </Breadcrumb>
   
    <section class="content">
      <div class="row">
          <div class="col-md-12">
          <!-- Custom Tabs -->
              <div class="row">
                  <div class="col-md-12">
                      <div class="box box-info">
                          <div class="box-header with-border">
                          <i class="fa fa-road"></i>
                          <h3 class="box-title head-title-padding">Workflows</h3>
                          </div>
                          <!-- /.box-header -->
                          <!-- form start -->
                          
                          <div class="box-body table-responsive">
                          <div class="notdatatable form-inline mbottom-15">
                              <div class="table-controls table-columns">
                                  <div class="btn-group"><button ng-if="viewer.CanExport()" class="btn btn-default" type="button" ng-click="viewer.ExportExcel()"><span>Excel</span></button><button class="btn btn-default button-columns" type="button" id="Main_MyDashboard_Recent_TableControls_Visibility"><span>Column visibility</span></button></div>
                              </div>
                              <div class="table-controls table-pagesize table-columns">
                                  <label>
                                      Show 
                                      <select class="form-control input-xs">
                                      <option value="5">5</option>
                                      <option value="10">10</option>
                                      <option value="25">25</option>
                                      <option value="50">50</option>
                                      <option value="100">100</option>
                                      <option value="250">250</option>
                                      <option value="500">500</option>
                                      <option value="1000">1000</option>
                                      </select>
                                      entries 
                                  </label>
                              </div>
                              
                              <div class="table-controls table-filter">Filter Workflows <input type="search" class="form-control" id="Main_MyDashboard_Recent_TableControls_Filter"></div>
                          </div>
                          <table class="table table-striped table-hover">
                              <thead>
                              <tr id="row1">
                                  <!--<th class="no-sort"  name="name" width="30"></th>-->
                                  <th class="text-capitalize sorting">
                                      Workflow Name
                                  </th>
                                  <th class="text-capitalize sorting">
                                       ID
                                  </th>
                                  <th class="text-capitalize sorting">
                                       Description
                                  </th>
                                  <th class="text-capitalize sorting">
                                       Modify Time
                                  </th>
                                  <th class="text-capitalize sorting">
                                       Modifier
                                  </th>
                                  <th class="text-capitalize sorting">
                                       Change Description
                                  </th>
                                 
                              </tr>
                              </thead>
                              <tbody>
                              <tr id="row2" @click="showMessageDetails('','row2')" v-bind:class = "showDetails.active_el == 'row2' ?'row-active':''">
                                 
                                  <td>
                                      Test
                                  </td>
                                  <td>
                                     454
                                  </td>
                                  <td>
                                    test description
                                  </td>
                                  <td>
                                    2024-11-17 5:47:55 PM
                                  </td>
                                  <td>
                                     Jhon Doe
                                  </td>
                                  <td>
                                     new change
                                  </td>
                                 
                              </tr>
  
                              <tr id="row3" v-on:click="showMessageDetails('','row3')" v-bind:class = " showDetails.active_el == 'row3' ? 'row-active' : 'hell'">
                                <td>
                                      Test
                                  </td>
                                  <td>
                                     453
                                  </td>
                                  <td>
                                     test description
                                  </td>
                                  <td>
                                    2024-11-17 5:47:55 PM
                                  </td>
                                  <td>
                                     Jhon Doe
                                  </td>
                                  <td>
                                    new change
                                  </td>
                                 
                              </tr>
                              </tbody>
                          </table>
                          <div id="Main_MyDashboard_Recent_TableInfo">
                              <div class="notdatatable table-info">Showing 1 to 2 of 2 entries</div>
                              <div class="dataTables_paginate notdatatable table-pagination text-end">
                                  <ul class="pagination">
                                      <li><a href="">Previous</a></li>
                                      <li class="active"><a href="">1</a></li>
                                      <li><a href="">Next</a></li>
                                  </ul>
                              </div>
                              </div>
                          <!-- Data loader start
                          <div class="data-loader">
                              <i class="fa fa-spinner fa-spin fa-fw"></i>
                          </div>  -->
                          <!-- Data loader end-->
                          </div>
                      </div>
                  </div>
                  <div class="col-md-4">
                  </div>
              </div>
          </div>
          <!-- /.col -->
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <button  class="btn btn-primary" v-on:click="showNewWorkflow()">New Workflow</button>
            <button  class="btn btn-danger btn-delete" v-on:click="showDeleteWorkflow()">Delete workflow...</button>
          </div>
        </div>
      </div>
  
      <div class="expandedrowcontent box-bg-color" v-if="showDetails.showNew">
          <div class="box box-info with-border">
              <div class="box-body table-responsive">
                  <div class="box-header with-border">
                      <i class="fa fa-road"></i>
                      <h3 class="box-title text-right">New workflow</h3>
                  </div>
                  <div class="box-body">
                     <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label text-left">Workflow Name</label>
                                <input iservice-id="Name" type="text" class="form-control has-error"><!---->
                                <span>Workflow label is displayed to user and agents.</span>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label text-left">Workflow ID</label><input iservice-id="Name" type="text" class="form-control small-input has-error">
                                <span> Your ID cannot be used by another workflow or configuration and must be all lower case letters from a to z.</span>
                                <br>
                                <span>Workflow ID is used in page URLs.</span>
                                <br>
                                <span class="fw-bold"> (e.g. company.iservicecrm.com/wf/<span class="text-danger fw-bold">ourflow</span>/submit)</span>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label text-left">Add Workflow Description </label>
                                <textarea iservice-id="Name" type="text" class="form-control"></textarea><!---->
                            </div>
                        </div>
                        
                     </div>
                     <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label text-left">&nbsp;</label>
                                <div class="input-group">
                                    <button class="btn btn-primary mx-0" type="button" id="button-addon1">Create</button>
                                    <input type="text" class="form-control" placeholder="">
                                    
                                </div>
                                <span>Optional description of the current changes being saved. </span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="control-label text-left">Optional: Import a Workflow(Paste a workflow below to import its settings)</label>
                                <textarea iservice-id="Name" type="text" class="form-control"></textarea><!---->
                            </div>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-link" type="button">Cancel</button>
                        </div>
                     </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="row" v-if="showDetails.deleteworkflow">
          <div class="col-md-12" iservice-id-prefix="'Delete'">
              <div class="box box-danger" iservice-id="'Delete'">
                  <div class="box-header with-border">
                      <i class="fa fa-warning"></i>
                      <h3 cass="box-title text-right">Delete workflow</h3>
                  </div>
                  <div class="box-body">
                      <section class="box-content box-bg-color">
                      <div class="row">
                          <div class="form-horizontal">
                              <div class="col-md-12">
                                  <p class="text-danger">WARNING: Deletion is immediate and irrevocable.</p>
                              </div>
                          </div>
                          <div class="form-horizontal">
                              <div class="col-md-12"><button iservice-id="Confirm" class="btn btn-danger btn-sm">Confirm Deletion</button><button iservice-id="Cancel" class="btn btn-link" v-on:click="cancel()">Cancel</button></div>
                          </div>
                      </div>
                      </section>
                  </div>
              </div>
          </div>
      </div>
      <div  v-if="showDetails.showworkflowDetails">
        <div class="box box-info with-border">
            <div class="box-header with-border"><h3 class="box-title head-title-padding">Test - Workflow</h3></div>
              <div class="box-body table-responsive">
                  <div class="box-body">
                    <workflowForm form-title="workflows - Support issue"></workflowForm>
                  </div>
              </div>
          </div>
        
      </div>
    </section>
  </template>
  
  <script>
  import Breadcrumb from '../components/Breadcrumb.vue';
  import MyInboxMessages from '../components/MyInboxMessages.vue';
  import InboxMessageDetail from '../components/InboxMessageDetail.vue';
  import iServiceSwitch from '../components/iServiceSwitch.vue';
  import workflowForm from '../components/workflowForm.vue';
  
  import Multiselect from '@vueform/multiselect'
  import Vue from 'vue';
  import { reactive,ref, onMounted } from 'vue'
  export default {
    name: 'MyMessageInboxComponents',
     components: {
      Breadcrumb,
      MyInboxMessages,
      InboxMessageDetail,
      iServiceSwitch,
      Multiselect,
      workflowForm
    },
    setup(){      
         
         var showDetails = reactive({showNew:false,deleteworkflow:false, showworkflowDetails:false,currentRow:''});
         var showNew =   reactive(false);
         var deleteworkflow =  reactive(false);
         var show = reactive(false);
         var currentRow = '';
  
         function showNewWorkflow(){
           showDetails.showNew = true; 
           showDetails.deleteworkflow = false;  
           showDetails.showworkflowDetails = false;
           showDetails.active_el = '';
         }
         function showDeleteWorkflow(){
           showDetails.showNew = false; 
           showDetails.deleteworkflow = true;  
         }
         function showMessageDetails(val,row){
           showDetails.showNew = false; 
           showDetails.deleteworkflow = false;  
           showDetails.showworkflowDetails=true;
           showDetails.active_el = row;
         }
         function cancel(){
           showDetails.showNew = false; 
           showDetails.deleteworkflow = false;  
           showDetails.showworkflowDetails=false;
         }
  
         return{cancel,showNew,deleteworkflow,showDetails,showNewWorkflow,showDeleteWorkflow,showMessageDetails};
    }
  
  }
  </script>
  